import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';
import { Router } from '@angular/router';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { GridPageSettings, MenuFuncionCodes, SearchMovimientoItemDto } from '../../../../../src/app/shared/model';
import { MovimientoService, MenuFuncionService } from '../../../../../src/app/shared/services';

@Component({
  selector: 'app-misPagos',
  templateUrl: './misPagos.component.html',
  styleUrls: ['./misPagos.component.scss']
})

export class MisPagosComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  isValidating: boolean = false;
  isSearching: boolean = false;
  canView: boolean = false;
  canViewDetalle: boolean = false;

  formGroup: FormGroup;

  public data: DataManager;
  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  private subscription: Subscription;

  constructor(
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private service: MovimientoService,
    private menuService: MenuFuncionService,
    private eventEmitterService: EventEmiterService
  ) {
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView()
    });
   }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_MIS_MOVIMIENTOS_PAGOS).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.canView = true;
        this.menuService.checkMenu(MenuFuncionCodes.MIS_MOVIMIENTOS_LIST).subscribe(data => {
          if (data != null && data.Success && data?.Result)
            this.canViewDetalle = true;

          this.loadView();
        },
        (err: HttpErrorResponse) => {
          this.loadView();
          this.sharedFunctions.handleError(err);
        });
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };


    //this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getDashboardMisPagosUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    setTimeout(() => {
      if (this.grid?.getRows()?.length > 0)
        this.grid?.autoFitColumns()
    }, 1000);
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }

  onGridActionFailure(event: any): void {
    // this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
    console.error(event);
  }

  loadDashboard() {
    this.grid.refresh();
    setTimeout(() => {
      if (this.grid?.getRows()?.length > 0)
        this.grid?.autoFitColumns()
    }, 1000);
  }

  view(item: SearchMovimientoItemDto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['movimiento-view', item.Id]);
  }

  viewAll() {
    if (!this.canViewDetalle) {
      this.sharedFunctions.showMessage("No tiene permisos para llevar a cabo la operación", "Error");
      return false;
    }

    this.router.navigate(['mi-movimiento-list']);
  }
}
